// Yofis — контракт API `yofis.v1`. Чаты: личные, группы, каналы, комнаты; участники и роли.

// @generated by protoc-gen-es v2.15.0 with parameter "target=ts,import_extension=ts"
// @generated from file yofis/v1/chat.proto (package yofis.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { FieldMask, Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_field_mask, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { EncryptionMode, PageInfo, User } from "./common_pb.ts";
import { file_yofis_v1_common } from "./common_pb.ts";
import type { Message as Message$1 } from "./message_pb.ts";
import { file_yofis_v1_message } from "./message_pb.ts";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file yofis/v1/chat.proto.
 */
export const file_yofis_v1_chat: GenFile = /*@__PURE__*/
  fileDesc("ChN5b2Zpcy92MS9jaGF0LnByb3RvEgh5b2Zpcy52MSKOBAoEQ2hhdBIKCgJpZBgBIAEoCRITCgtob21lX2RvbWFpbhgCIAEoCRIgCgR0eXBlGAMgASgOMhIueW9maXMudjEuQ2hhdFR5cGUSDQoFdGl0bGUYBCABKAkSFgoOYXZhdGFyX2ZpbGVfaWQYBSABKAkSFAoMcGVlcl9hZGRyZXNzGAYgASgJEhQKDG1lbWJlcl9jb3VudBgHIAEoBRIoCghzZXR0aW5ncxgIIAEoCzIWLnlvZmlzLnYxLkNoYXRTZXR0aW5ncxIlCgdteV9yb2xlGAkgASgOMhQueW9maXMudjEuTWVtYmVyUm9sZRInCgxsYXN0X21lc3NhZ2UYCiABKAsyES55b2Zpcy52MS5NZXNzYWdlEhQKDHVucmVhZF9jb3VudBgLIAEoAxIcChRsYXN0X3JlYWRfbWVzc2FnZV9pZBgMIAEoCRINCgVtdXRlZBgNIAEoCBIOCgZwaW5uZWQYDiABKAgSEAoIYXJjaGl2ZWQYDyABKAgSLgoKY3JlYXRlZF9hdBgQIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXASLgoKdXBkYXRlZF9hdBgRIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXASMQoPZW5jcnlwdGlvbl9tb2RlGBIgASgOMhgueW9maXMudjEuRW5jcnlwdGlvbk1vZGUiiwEKDENoYXRTZXR0aW5ncxImCh5oaXN0b3J5X3Zpc2libGVfdG9fbmV3X21lbWJlcnMYASABKAgSGAoQb25seV9hZG1pbnNfcG9zdBgCIAEoCBIaChJvbmx5X2FkbWluc19pbnZpdGUYAyABKAgSHQoVb25seV9hZG1pbnNfZWRpdF9pbmZvGAQgASgIIqgBCgZNZW1iZXISDwoHYWRkcmVzcxgBIAEoCRIiCgRyb2xlGAIgASgOMhQueW9maXMudjEuTWVtYmVyUm9sZRItCglqb2luZWRfYXQYAyABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wEhwKFGxhc3RfcmVhZF9tZXNzYWdlX2lkGAQgASgJEhwKBHVzZXIYBSABKAsyDi55b2Zpcy52MS5Vc2VyIi8KF0NyZWF0ZURpcmVjdENoYXRSZXF1ZXN0EhQKDHBlZXJfYWRkcmVzcxgBIAEoCSI4ChhDcmVhdGVEaXJlY3RDaGF0UmVzcG9uc2USHAoEY2hhdBgBIAEoCzIOLnlvZmlzLnYxLkNoYXQigAEKEkNyZWF0ZUdyb3VwUmVxdWVzdBINCgV0aXRsZRgBIAEoCRIYChBtZW1iZXJfYWRkcmVzc2VzGAIgAygJEigKCHNldHRpbmdzGAMgASgLMhYueW9maXMudjEuQ2hhdFNldHRpbmdzEhcKD2lkZW1wb3RlbmN5X2tleRgEIAEoCSIzChNDcmVhdGVHcm91cFJlc3BvbnNlEhwKBGNoYXQYASABKAsyDi55b2Zpcy52MS5DaGF0ImgKFENyZWF0ZUNoYW5uZWxSZXF1ZXN0Eg0KBXRpdGxlGAEgASgJEigKCHNldHRpbmdzGAIgASgLMhYueW9maXMudjEuQ2hhdFNldHRpbmdzEhcKD2lkZW1wb3RlbmN5X2tleRgDIAEoCSI1ChVDcmVhdGVDaGFubmVsUmVzcG9uc2USHAoEY2hhdBgBIAEoCzIOLnlvZmlzLnYxLkNoYXQiIQoOR2V0Q2hhdFJlcXVlc3QSDwoHY2hhdF9pZBgBIAEoCSIvCg9HZXRDaGF0UmVzcG9uc2USHAoEY2hhdBgBIAEoCzIOLnlvZmlzLnYxLkNoYXQiSwoQTGlzdENoYXRzUmVxdWVzdBIOCgZjdXJzb3IYASABKAkSDQoFbGltaXQYAiABKAUSGAoQaW5jbHVkZV9hcmNoaXZlZBgDIAEoCCJUChFMaXN0Q2hhdHNSZXNwb25zZRIdCgVjaGF0cxgBIAMoCzIOLnlvZmlzLnYxLkNoYXQSIAoEcGFnZRgCIAEoCzISLnlvZmlzLnYxLlBhZ2VJbmZvInMKEVVwZGF0ZUNoYXRSZXF1ZXN0Eg8KB2NoYXRfaWQYASABKAkSHAoEY2hhdBgCIAEoCzIOLnlvZmlzLnYxLkNoYXQSLwoLdXBkYXRlX21hc2sYAyABKAsyGi5nb29nbGUucHJvdG9idWYuRmllbGRNYXNrIjIKElVwZGF0ZUNoYXRSZXNwb25zZRIcCgRjaGF0GAEgASgLMg4ueW9maXMudjEuQ2hhdCI3ChFBZGRNZW1iZXJzUmVxdWVzdBIPCgdjaGF0X2lkGAEgASgJEhEKCWFkZHJlc3NlcxgCIAMoCSI3ChJBZGRNZW1iZXJzUmVzcG9uc2USIQoHbWVtYmVycxgBIAMoCzIQLnlvZmlzLnYxLk1lbWJlciI3ChNSZW1vdmVNZW1iZXJSZXF1ZXN0Eg8KB2NoYXRfaWQYASABKAkSDwoHYWRkcmVzcxgCIAEoCSIWChRSZW1vdmVNZW1iZXJSZXNwb25zZSIjChBMZWF2ZUNoYXRSZXF1ZXN0Eg8KB2NoYXRfaWQYASABKAkiEwoRTGVhdmVDaGF0UmVzcG9uc2UiXAoUU2V0TWVtYmVyUm9sZVJlcXVlc3QSDwoHY2hhdF9pZBgBIAEoCRIPCgdhZGRyZXNzGAIgASgJEiIKBHJvbGUYAyABKA4yFC55b2Zpcy52MS5NZW1iZXJSb2xlIjkKFVNldE1lbWJlclJvbGVSZXNwb25zZRIgCgZtZW1iZXIYASABKAsyEC55b2Zpcy52MS5NZW1iZXIiRAoSTGlzdE1lbWJlcnNSZXF1ZXN0Eg8KB2NoYXRfaWQYASABKAkSDgoGY3Vyc29yGAIgASgJEg0KBWxpbWl0GAMgASgFIloKE0xpc3RNZW1iZXJzUmVzcG9uc2USIQoHbWVtYmVycxgBIAMoCzIQLnlvZmlzLnYxLk1lbWJlchIgCgRwYWdlGAIgASgLMhIueW9maXMudjEuUGFnZUluZm8iNgoPTWFya1JlYWRSZXF1ZXN0Eg8KB2NoYXRfaWQYASABKAkSEgoKbWVzc2FnZV9pZBgCIAEoCSISChBNYXJrUmVhZFJlc3BvbnNlIjMKEFNldFR5cGluZ1JlcXVlc3QSDwoHY2hhdF9pZBgBIAEoCRIOCgZ0eXBpbmcYAiABKAgiEwoRU2V0VHlwaW5nUmVzcG9uc2UiiAEKE1NldENoYXRQcmVmc1JlcXVlc3QSDwoHY2hhdF9pZBgBIAEoCRINCgVtdXRlZBgCIAEoCBIOCgZwaW5uZWQYAyABKAgSEAoIYXJjaGl2ZWQYBCABKAgSLwoLdXBkYXRlX21hc2sYBSABKAsyGi5nb29nbGUucHJvdG9idWYuRmllbGRNYXNrIjQKFFNldENoYXRQcmVmc1Jlc3BvbnNlEhwKBGNoYXQYASABKAsyDi55b2Zpcy52MS5DaGF0IiQKEURlbGV0ZUNoYXRSZXF1ZXN0Eg8KB2NoYXRfaWQYASABKAkiFAoSRGVsZXRlQ2hhdFJlc3BvbnNlKpEBCghDaGF0VHlwZRIZChVDSEFUX1RZUEVfVU5TUEVDSUZJRUQQABIUChBDSEFUX1RZUEVfRElSRUNUEAESEwoPQ0hBVF9UWVBFX0dST1VQEAISFQoRQ0hBVF9UWVBFX0NIQU5ORUwQAxISCg5DSEFUX1RZUEVfUk9PTRAEEhQKEENIQVRfVFlQRV9TRUNSRVQQBSqGAQoKTWVtYmVyUm9sZRIbChdNRU1CRVJfUk9MRV9VTlNQRUNJRklFRBAAEhUKEU1FTUJFUl9ST0xFX09XTkVSEAESFQoRTUVNQkVSX1JPTEVfQURNSU4QAhIWChJNRU1CRVJfUk9MRV9NRU1CRVIQAxIVChFNRU1CRVJfUk9MRV9HVUVTVBAEMvIICgtDaGF0U2VydmljZRJZChBDcmVhdGVEaXJlY3RDaGF0EiEueW9maXMudjEuQ3JlYXRlRGlyZWN0Q2hhdFJlcXVlc3QaIi55b2Zpcy52MS5DcmVhdGVEaXJlY3RDaGF0UmVzcG9uc2USSgoLQ3JlYXRlR3JvdXASHC55b2Zpcy52MS5DcmVhdGVHcm91cFJlcXVlc3QaHS55b2Zpcy52MS5DcmVhdGVHcm91cFJlc3BvbnNlElAKDUNyZWF0ZUNoYW5uZWwSHi55b2Zpcy52MS5DcmVhdGVDaGFubmVsUmVxdWVzdBofLnlvZmlzLnYxLkNyZWF0ZUNoYW5uZWxSZXNwb25zZRI+CgdHZXRDaGF0EhgueW9maXMudjEuR2V0Q2hhdFJlcXVlc3QaGS55b2Zpcy52MS5HZXRDaGF0UmVzcG9uc2USRAoJTGlzdENoYXRzEhoueW9maXMudjEuTGlzdENoYXRzUmVxdWVzdBobLnlvZmlzLnYxLkxpc3RDaGF0c1Jlc3BvbnNlEkcKClVwZGF0ZUNoYXQSGy55b2Zpcy52MS5VcGRhdGVDaGF0UmVxdWVzdBocLnlvZmlzLnYxLlVwZGF0ZUNoYXRSZXNwb25zZRJHCgpBZGRNZW1iZXJzEhsueW9maXMudjEuQWRkTWVtYmVyc1JlcXVlc3QaHC55b2Zpcy52MS5BZGRNZW1iZXJzUmVzcG9uc2USTQoMUmVtb3ZlTWVtYmVyEh0ueW9maXMudjEuUmVtb3ZlTWVtYmVyUmVxdWVzdBoeLnlvZmlzLnYxLlJlbW92ZU1lbWJlclJlc3BvbnNlEkQKCUxlYXZlQ2hhdBIaLnlvZmlzLnYxLkxlYXZlQ2hhdFJlcXVlc3QaGy55b2Zpcy52MS5MZWF2ZUNoYXRSZXNwb25zZRJQCg1TZXRNZW1iZXJSb2xlEh4ueW9maXMudjEuU2V0TWVtYmVyUm9sZVJlcXVlc3QaHy55b2Zpcy52MS5TZXRNZW1iZXJSb2xlUmVzcG9uc2USSgoLTGlzdE1lbWJlcnMSHC55b2Zpcy52MS5MaXN0TWVtYmVyc1JlcXVlc3QaHS55b2Zpcy52MS5MaXN0TWVtYmVyc1Jlc3BvbnNlEkEKCE1hcmtSZWFkEhkueW9maXMudjEuTWFya1JlYWRSZXF1ZXN0GhoueW9maXMudjEuTWFya1JlYWRSZXNwb25zZRJECglTZXRUeXBpbmcSGi55b2Zpcy52MS5TZXRUeXBpbmdSZXF1ZXN0GhsueW9maXMudjEuU2V0VHlwaW5nUmVzcG9uc2USTQoMU2V0Q2hhdFByZWZzEh0ueW9maXMudjEuU2V0Q2hhdFByZWZzUmVxdWVzdBoeLnlvZmlzLnYxLlNldENoYXRQcmVmc1Jlc3BvbnNlEkcKCkRlbGV0ZUNoYXQSGy55b2Zpcy52MS5EZWxldGVDaGF0UmVxdWVzdBocLnlvZmlzLnYxLkRlbGV0ZUNoYXRSZXNwb25zZUJFChFydS55b2Zpcy5wcm90by52MVABWiZ5b2Zpcy5ydS95b2Zpcy9nZW4vZ28veW9maXMvdjE7eW9maXN2MboCBVlvZmlzYgZwcm90bzM", [file_google_protobuf_field_mask, file_google_protobuf_timestamp, file_yofis_v1_common, file_yofis_v1_message]);

/**
 * Чат.
 *
 * @generated from message yofis.v1.Chat
 */
export type Chat = Message<"yofis.v1.Chat"> & {
  /**
   * Идентификатор `<snowflake>@<home_domain>` (ADR-024).
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Домашний сервер чата — авторитет порядка сообщений (ADR-008).
   *
   * @generated from field: string home_domain = 2;
   */
  homeDomain: string;

  /**
   * Тип чата.
   *
   * @generated from field: yofis.v1.ChatType type = 3;
   */
  type: ChatType;

  /**
   * Название; для DIRECT пусто — клиент показывает собеседника.
   *
   * @generated from field: string title = 4;
   */
  title: string;

  /**
   * Аватар чата; для DIRECT пусто.
   *
   * @generated from field: string avatar_file_id = 5;
   */
  avatarFileId: string;

  /**
   * Адрес собеседника; только DIRECT.
   *
   * @generated from field: string peer_address = 6;
   */
  peerAddress: string;

  /**
   * Число участников.
   *
   * @generated from field: int32 member_count = 7;
   */
  memberCount: number;

  /**
   * Настройки чата.
   *
   * @generated from field: yofis.v1.ChatSettings settings = 8;
   */
  settings?: ChatSettings | undefined;

  /**
   * Моя роль в чате.
   *
   * @generated from field: yofis.v1.MemberRole my_role = 9;
   */
  myRole: MemberRole;

  /**
   * Последнее сообщение для списка чатов.
   *
   * @generated from field: yofis.v1.Message last_message = 10;
   */
  lastMessage?: Message$1 | undefined;

  /**
   * Непрочитанных у меня.
   *
   * @generated from field: int64 unread_count = 11;
   */
  unreadCount: bigint;

  /**
   * Моя отметка прочтения (идентификатор последнего прочитанного).
   *
   * @generated from field: string last_read_message_id = 12;
   */
  lastReadMessageId: string;

  /**
   * Без звука (личная настройка).
   *
   * @generated from field: bool muted = 13;
   */
  muted: boolean;

  /**
   * Закреплён в списке (личная настройка).
   *
   * @generated from field: bool pinned = 14;
   */
  pinned: boolean;

  /**
   * В архиве (личная настройка).
   *
   * @generated from field: bool archived = 15;
   */
  archived: boolean;

  /**
   * Когда создан.
   *
   * @generated from field: google.protobuf.Timestamp created_at = 16;
   */
  createdAt?: Timestamp | undefined;

  /**
   * Последнее изменение (сообщение, состав, настройки) — для сортировки списка.
   *
   * @generated from field: google.protobuf.Timestamp updated_at = 17;
   */
  updatedAt?: Timestamp | undefined;

  /**
   * Режим шифрования; v1 — SERVER.
   *
   * @generated from field: yofis.v1.EncryptionMode encryption_mode = 18;
   */
  encryptionMode: EncryptionMode;
};

/**
 * Describes the message yofis.v1.Chat.
 * Use `create(ChatSchema)` to create a new message.
 */
export const ChatSchema: GenMessage<Chat> = /*@__PURE__*/
  messageDesc(file_yofis_v1_chat, 0);

/**
 * Настройки чата (правят ADMIN/OWNER).
 *
 * @generated from message yofis.v1.ChatSettings
 */
export type ChatSettings = Message<"yofis.v1.ChatSettings"> & {
  /**
   * Новые участники видят историю до вступления; по умолчанию true.
   *
   * @generated from field: bool history_visible_to_new_members = 1;
   */
  historyVisibleToNewMembers: boolean;

  /**
   * Писать могут только администраторы; для CHANNEL всегда true.
   *
   * @generated from field: bool only_admins_post = 2;
   */
  onlyAdminsPost: boolean;

  /**
   * Приглашать могут только администраторы.
   *
   * @generated from field: bool only_admins_invite = 3;
   */
  onlyAdminsInvite: boolean;

  /**
   * Менять название, аватар и настройки могут только администраторы.
   *
   * @generated from field: bool only_admins_edit_info = 4;
   */
  onlyAdminsEditInfo: boolean;
};

/**
 * Describes the message yofis.v1.ChatSettings.
 * Use `create(ChatSettingsSchema)` to create a new message.
 */
export const ChatSettingsSchema: GenMessage<ChatSettings> = /*@__PURE__*/
  messageDesc(file_yofis_v1_chat, 1);

/**
 * Участник чата.
 *
 * @generated from message yofis.v1.Member
 */
export type Member = Message<"yofis.v1.Member"> & {
  /**
   * Адрес.
   *
   * @generated from field: string address = 1;
   */
  address: string;

  /**
   * Роль.
   *
   * @generated from field: yofis.v1.MemberRole role = 2;
   */
  role: MemberRole;

  /**
   * Когда вступил.
   *
   * @generated from field: google.protobuf.Timestamp joined_at = 3;
   */
  joinedAt?: Timestamp | undefined;

  /**
   * Его отметка прочтения (для галочек «прочитано»).
   *
   * @generated from field: string last_read_message_id = 4;
   */
  lastReadMessageId: string;

  /**
   * Профиль (заполняется в `ListMembers`, `AddMembers`).
   *
   * @generated from field: yofis.v1.User user = 5;
   */
  user?: User | undefined;
};

/**
 * Describes the message yofis.v1.Member.
 * Use `create(MemberSchema)` to create a new message.
 */
export const MemberSchema: GenMessage<Member> = /*@__PURE__*/
  messageDesc(file_yofis_v1_chat, 2);

/**
 * Создание личного чата.
 *
 * @generated from message yofis.v1.CreateDirectChatRequest
 */
export type CreateDirectChatRequest = Message<"yofis.v1.CreateDirectChatRequest"> & {
  /**
   * Адрес собеседника.
   *
   * @generated from field: string peer_address = 1;
   */
  peerAddress: string;
};

/**
 * Describes the message yofis.v1.CreateDirectChatRequest.
 * Use `create(CreateDirectChatRequestSchema)` to create a new message.
 */
export const CreateDirectChatRequestSchema: GenMessage<CreateDirectChatRequest> = /*@__PURE__*/
  messageDesc(file_yofis_v1_chat, 3);

/**
 * Ответ на создание личного чата.
 *
 * @generated from message yofis.v1.CreateDirectChatResponse
 */
export type CreateDirectChatResponse = Message<"yofis.v1.CreateDirectChatResponse"> & {
  /**
   * Чат (новый или существующий).
   *
   * @generated from field: yofis.v1.Chat chat = 1;
   */
  chat?: Chat | undefined;
};

/**
 * Describes the message yofis.v1.CreateDirectChatResponse.
 * Use `create(CreateDirectChatResponseSchema)` to create a new message.
 */
export const CreateDirectChatResponseSchema: GenMessage<CreateDirectChatResponse> = /*@__PURE__*/
  messageDesc(file_yofis_v1_chat, 4);

/**
 * Создание группы.
 *
 * @generated from message yofis.v1.CreateGroupRequest
 */
export type CreateGroupRequest = Message<"yofis.v1.CreateGroupRequest"> & {
  /**
   * Название.
   *
   * @generated from field: string title = 1;
   */
  title: string;

  /**
   * Адреса первых участников (без создателя).
   *
   * @generated from field: repeated string member_addresses = 2;
   */
  memberAddresses: string[];

  /**
   * Настройки; пусто — значения по умолчанию.
   *
   * @generated from field: yofis.v1.ChatSettings settings = 3;
   */
  settings?: ChatSettings | undefined;

  /**
   * Ключ идемпотентности (UUIDv7): повтор с тем же ключом возвращает тот же чат.
   *
   * @generated from field: string idempotency_key = 4;
   */
  idempotencyKey: string;
};

/**
 * Describes the message yofis.v1.CreateGroupRequest.
 * Use `create(CreateGroupRequestSchema)` to create a new message.
 */
export const CreateGroupRequestSchema: GenMessage<CreateGroupRequest> = /*@__PURE__*/
  messageDesc(file_yofis_v1_chat, 5);

/**
 * Ответ на создание группы.
 *
 * @generated from message yofis.v1.CreateGroupResponse
 */
export type CreateGroupResponse = Message<"yofis.v1.CreateGroupResponse"> & {
  /**
   * Созданная группа.
   *
   * @generated from field: yofis.v1.Chat chat = 1;
   */
  chat?: Chat | undefined;
};

/**
 * Describes the message yofis.v1.CreateGroupResponse.
 * Use `create(CreateGroupResponseSchema)` to create a new message.
 */
export const CreateGroupResponseSchema: GenMessage<CreateGroupResponse> = /*@__PURE__*/
  messageDesc(file_yofis_v1_chat, 6);

/**
 * Создание канала.
 *
 * @generated from message yofis.v1.CreateChannelRequest
 */
export type CreateChannelRequest = Message<"yofis.v1.CreateChannelRequest"> & {
  /**
   * Название.
   *
   * @generated from field: string title = 1;
   */
  title: string;

  /**
   * Настройки; `only_admins_post` всегда true.
   *
   * @generated from field: yofis.v1.ChatSettings settings = 2;
   */
  settings?: ChatSettings | undefined;

  /**
   * Ключ идемпотентности.
   *
   * @generated from field: string idempotency_key = 3;
   */
  idempotencyKey: string;
};

/**
 * Describes the message yofis.v1.CreateChannelRequest.
 * Use `create(CreateChannelRequestSchema)` to create a new message.
 */
export const CreateChannelRequestSchema: GenMessage<CreateChannelRequest> = /*@__PURE__*/
  messageDesc(file_yofis_v1_chat, 7);

/**
 * Ответ на создание канала.
 *
 * @generated from message yofis.v1.CreateChannelResponse
 */
export type CreateChannelResponse = Message<"yofis.v1.CreateChannelResponse"> & {
  /**
   * Созданный канал.
   *
   * @generated from field: yofis.v1.Chat chat = 1;
   */
  chat?: Chat | undefined;
};

/**
 * Describes the message yofis.v1.CreateChannelResponse.
 * Use `create(CreateChannelResponseSchema)` to create a new message.
 */
export const CreateChannelResponseSchema: GenMessage<CreateChannelResponse> = /*@__PURE__*/
  messageDesc(file_yofis_v1_chat, 8);

/**
 * Запрос чата.
 *
 * @generated from message yofis.v1.GetChatRequest
 */
export type GetChatRequest = Message<"yofis.v1.GetChatRequest"> & {
  /**
   * Идентификатор чата.
   *
   * @generated from field: string chat_id = 1;
   */
  chatId: string;
};

/**
 * Describes the message yofis.v1.GetChatRequest.
 * Use `create(GetChatRequestSchema)` to create a new message.
 */
export const GetChatRequestSchema: GenMessage<GetChatRequest> = /*@__PURE__*/
  messageDesc(file_yofis_v1_chat, 9);

/**
 * Ответ с чатом.
 *
 * @generated from message yofis.v1.GetChatResponse
 */
export type GetChatResponse = Message<"yofis.v1.GetChatResponse"> & {
  /**
   * Чат.
   *
   * @generated from field: yofis.v1.Chat chat = 1;
   */
  chat?: Chat | undefined;
};

/**
 * Describes the message yofis.v1.GetChatResponse.
 * Use `create(GetChatResponseSchema)` to create a new message.
 */
export const GetChatResponseSchema: GenMessage<GetChatResponse> = /*@__PURE__*/
  messageDesc(file_yofis_v1_chat, 10);

/**
 * Запрос списка чатов.
 *
 * @generated from message yofis.v1.ListChatsRequest
 */
export type ListChatsRequest = Message<"yofis.v1.ListChatsRequest"> & {
  /**
   * Курсор страницы.
   *
   * @generated from field: string cursor = 1;
   */
  cursor: string;

  /**
   * Размер страницы; по умолчанию 50, максимум 200.
   *
   * @generated from field: int32 limit = 2;
   */
  limit: number;

  /**
   * Включать архивные.
   *
   * @generated from field: bool include_archived = 3;
   */
  includeArchived: boolean;
};

/**
 * Describes the message yofis.v1.ListChatsRequest.
 * Use `create(ListChatsRequestSchema)` to create a new message.
 */
export const ListChatsRequestSchema: GenMessage<ListChatsRequest> = /*@__PURE__*/
  messageDesc(file_yofis_v1_chat, 11);

/**
 * Ответ со списком чатов.
 *
 * @generated from message yofis.v1.ListChatsResponse
 */
export type ListChatsResponse = Message<"yofis.v1.ListChatsResponse"> & {
  /**
   * Чаты: закреплённые, затем по `updated_at` по убыванию.
   *
   * @generated from field: repeated yofis.v1.Chat chats = 1;
   */
  chats: Chat[];

  /**
   * Пагинация.
   *
   * @generated from field: yofis.v1.PageInfo page = 2;
   */
  page?: PageInfo | undefined;
};

/**
 * Describes the message yofis.v1.ListChatsResponse.
 * Use `create(ListChatsResponseSchema)` to create a new message.
 */
export const ListChatsResponseSchema: GenMessage<ListChatsResponse> = /*@__PURE__*/
  messageDesc(file_yofis_v1_chat, 12);

/**
 * Обновление чата.
 *
 * @generated from message yofis.v1.UpdateChatRequest
 */
export type UpdateChatRequest = Message<"yofis.v1.UpdateChatRequest"> & {
  /**
   * Идентификатор чата.
   *
   * @generated from field: string chat_id = 1;
   */
  chatId: string;

  /**
   * Новые значения; читаются только поля из `update_mask`.
   *
   * @generated from field: yofis.v1.Chat chat = 2;
   */
  chat?: Chat | undefined;

  /**
   * Какие поля менять: `title`, `avatar_file_id`, `settings` (или `settings.<поле>`).
   *
   * @generated from field: google.protobuf.FieldMask update_mask = 3;
   */
  updateMask?: FieldMask | undefined;
};

/**
 * Describes the message yofis.v1.UpdateChatRequest.
 * Use `create(UpdateChatRequestSchema)` to create a new message.
 */
export const UpdateChatRequestSchema: GenMessage<UpdateChatRequest> = /*@__PURE__*/
  messageDesc(file_yofis_v1_chat, 13);

/**
 * Ответ на обновление чата.
 *
 * @generated from message yofis.v1.UpdateChatResponse
 */
export type UpdateChatResponse = Message<"yofis.v1.UpdateChatResponse"> & {
  /**
   * Чат после обновления.
   *
   * @generated from field: yofis.v1.Chat chat = 1;
   */
  chat?: Chat | undefined;
};

/**
 * Describes the message yofis.v1.UpdateChatResponse.
 * Use `create(UpdateChatResponseSchema)` to create a new message.
 */
export const UpdateChatResponseSchema: GenMessage<UpdateChatResponse> = /*@__PURE__*/
  messageDesc(file_yofis_v1_chat, 14);

/**
 * Добавление участников.
 *
 * @generated from message yofis.v1.AddMembersRequest
 */
export type AddMembersRequest = Message<"yofis.v1.AddMembersRequest"> & {
  /**
   * Идентификатор чата.
   *
   * @generated from field: string chat_id = 1;
   */
  chatId: string;

  /**
   * Адреса.
   *
   * @generated from field: repeated string addresses = 2;
   */
  addresses: string[];
};

/**
 * Describes the message yofis.v1.AddMembersRequest.
 * Use `create(AddMembersRequestSchema)` to create a new message.
 */
export const AddMembersRequestSchema: GenMessage<AddMembersRequest> = /*@__PURE__*/
  messageDesc(file_yofis_v1_chat, 15);

/**
 * Ответ на добавление участников.
 *
 * @generated from message yofis.v1.AddMembersResponse
 */
export type AddMembersResponse = Message<"yofis.v1.AddMembersResponse"> & {
  /**
   * Добавленные участники (уже состоявшие — пропущены).
   *
   * @generated from field: repeated yofis.v1.Member members = 1;
   */
  members: Member[];
};

/**
 * Describes the message yofis.v1.AddMembersResponse.
 * Use `create(AddMembersResponseSchema)` to create a new message.
 */
export const AddMembersResponseSchema: GenMessage<AddMembersResponse> = /*@__PURE__*/
  messageDesc(file_yofis_v1_chat, 16);

/**
 * Удаление участника.
 *
 * @generated from message yofis.v1.RemoveMemberRequest
 */
export type RemoveMemberRequest = Message<"yofis.v1.RemoveMemberRequest"> & {
  /**
   * Идентификатор чата.
   *
   * @generated from field: string chat_id = 1;
   */
  chatId: string;

  /**
   * Адрес.
   *
   * @generated from field: string address = 2;
   */
  address: string;
};

/**
 * Describes the message yofis.v1.RemoveMemberRequest.
 * Use `create(RemoveMemberRequestSchema)` to create a new message.
 */
export const RemoveMemberRequestSchema: GenMessage<RemoveMemberRequest> = /*@__PURE__*/
  messageDesc(file_yofis_v1_chat, 17);

/**
 * Ответ на удаление участника; полей нет.
 *
 * @generated from message yofis.v1.RemoveMemberResponse
 */
export type RemoveMemberResponse = Message<"yofis.v1.RemoveMemberResponse"> & {
};

/**
 * Describes the message yofis.v1.RemoveMemberResponse.
 * Use `create(RemoveMemberResponseSchema)` to create a new message.
 */
export const RemoveMemberResponseSchema: GenMessage<RemoveMemberResponse> = /*@__PURE__*/
  messageDesc(file_yofis_v1_chat, 18);

/**
 * Выход из чата.
 *
 * @generated from message yofis.v1.LeaveChatRequest
 */
export type LeaveChatRequest = Message<"yofis.v1.LeaveChatRequest"> & {
  /**
   * Идентификатор чата.
   *
   * @generated from field: string chat_id = 1;
   */
  chatId: string;
};

/**
 * Describes the message yofis.v1.LeaveChatRequest.
 * Use `create(LeaveChatRequestSchema)` to create a new message.
 */
export const LeaveChatRequestSchema: GenMessage<LeaveChatRequest> = /*@__PURE__*/
  messageDesc(file_yofis_v1_chat, 19);

/**
 * Ответ на выход; полей нет.
 *
 * @generated from message yofis.v1.LeaveChatResponse
 */
export type LeaveChatResponse = Message<"yofis.v1.LeaveChatResponse"> & {
};

/**
 * Describes the message yofis.v1.LeaveChatResponse.
 * Use `create(LeaveChatResponseSchema)` to create a new message.
 */
export const LeaveChatResponseSchema: GenMessage<LeaveChatResponse> = /*@__PURE__*/
  messageDesc(file_yofis_v1_chat, 20);

/**
 * Смена роли участника.
 *
 * @generated from message yofis.v1.SetMemberRoleRequest
 */
export type SetMemberRoleRequest = Message<"yofis.v1.SetMemberRoleRequest"> & {
  /**
   * Идентификатор чата.
   *
   * @generated from field: string chat_id = 1;
   */
  chatId: string;

  /**
   * Адрес участника.
   *
   * @generated from field: string address = 2;
   */
  address: string;

  /**
   * Новая роль.
   *
   * @generated from field: yofis.v1.MemberRole role = 3;
   */
  role: MemberRole;
};

/**
 * Describes the message yofis.v1.SetMemberRoleRequest.
 * Use `create(SetMemberRoleRequestSchema)` to create a new message.
 */
export const SetMemberRoleRequestSchema: GenMessage<SetMemberRoleRequest> = /*@__PURE__*/
  messageDesc(file_yofis_v1_chat, 21);

/**
 * Ответ на смену роли.
 *
 * @generated from message yofis.v1.SetMemberRoleResponse
 */
export type SetMemberRoleResponse = Message<"yofis.v1.SetMemberRoleResponse"> & {
  /**
   * Участник с новой ролью.
   *
   * @generated from field: yofis.v1.Member member = 1;
   */
  member?: Member | undefined;
};

/**
 * Describes the message yofis.v1.SetMemberRoleResponse.
 * Use `create(SetMemberRoleResponseSchema)` to create a new message.
 */
export const SetMemberRoleResponseSchema: GenMessage<SetMemberRoleResponse> = /*@__PURE__*/
  messageDesc(file_yofis_v1_chat, 22);

/**
 * Запрос участников.
 *
 * @generated from message yofis.v1.ListMembersRequest
 */
export type ListMembersRequest = Message<"yofis.v1.ListMembersRequest"> & {
  /**
   * Идентификатор чата.
   *
   * @generated from field: string chat_id = 1;
   */
  chatId: string;

  /**
   * Курсор страницы.
   *
   * @generated from field: string cursor = 2;
   */
  cursor: string;

  /**
   * Размер страницы; по умолчанию 50, максимум 200.
   *
   * @generated from field: int32 limit = 3;
   */
  limit: number;
};

/**
 * Describes the message yofis.v1.ListMembersRequest.
 * Use `create(ListMembersRequestSchema)` to create a new message.
 */
export const ListMembersRequestSchema: GenMessage<ListMembersRequest> = /*@__PURE__*/
  messageDesc(file_yofis_v1_chat, 23);

/**
 * Ответ с участниками.
 *
 * @generated from message yofis.v1.ListMembersResponse
 */
export type ListMembersResponse = Message<"yofis.v1.ListMembersResponse"> & {
  /**
   * Участники с профилями; порядок: OWNER, ADMIN, затем по имени.
   *
   * @generated from field: repeated yofis.v1.Member members = 1;
   */
  members: Member[];

  /**
   * Пагинация.
   *
   * @generated from field: yofis.v1.PageInfo page = 2;
   */
  page?: PageInfo | undefined;
};

/**
 * Describes the message yofis.v1.ListMembersResponse.
 * Use `create(ListMembersResponseSchema)` to create a new message.
 */
export const ListMembersResponseSchema: GenMessage<ListMembersResponse> = /*@__PURE__*/
  messageDesc(file_yofis_v1_chat, 24);

/**
 * Отметка прочтения.
 *
 * @generated from message yofis.v1.MarkReadRequest
 */
export type MarkReadRequest = Message<"yofis.v1.MarkReadRequest"> & {
  /**
   * Идентификатор чата.
   *
   * @generated from field: string chat_id = 1;
   */
  chatId: string;

  /**
   * Последнее прочитанное сообщение.
   *
   * @generated from field: string message_id = 2;
   */
  messageId: string;
};

/**
 * Describes the message yofis.v1.MarkReadRequest.
 * Use `create(MarkReadRequestSchema)` to create a new message.
 */
export const MarkReadRequestSchema: GenMessage<MarkReadRequest> = /*@__PURE__*/
  messageDesc(file_yofis_v1_chat, 25);

/**
 * Ответ на отметку прочтения; полей нет.
 *
 * @generated from message yofis.v1.MarkReadResponse
 */
export type MarkReadResponse = Message<"yofis.v1.MarkReadResponse"> & {
};

/**
 * Describes the message yofis.v1.MarkReadResponse.
 * Use `create(MarkReadResponseSchema)` to create a new message.
 */
export const MarkReadResponseSchema: GenMessage<MarkReadResponse> = /*@__PURE__*/
  messageDesc(file_yofis_v1_chat, 26);

/**
 * Индикатор набора текста.
 *
 * @generated from message yofis.v1.SetTypingRequest
 */
export type SetTypingRequest = Message<"yofis.v1.SetTypingRequest"> & {
  /**
   * Идентификатор чата.
   *
   * @generated from field: string chat_id = 1;
   */
  chatId: string;

  /**
   * true — печатаю, false — перестал.
   *
   * @generated from field: bool typing = 2;
   */
  typing: boolean;
};

/**
 * Describes the message yofis.v1.SetTypingRequest.
 * Use `create(SetTypingRequestSchema)` to create a new message.
 */
export const SetTypingRequestSchema: GenMessage<SetTypingRequest> = /*@__PURE__*/
  messageDesc(file_yofis_v1_chat, 27);

/**
 * Ответ на индикатор набора; полей нет.
 *
 * @generated from message yofis.v1.SetTypingResponse
 */
export type SetTypingResponse = Message<"yofis.v1.SetTypingResponse"> & {
};

/**
 * Describes the message yofis.v1.SetTypingResponse.
 * Use `create(SetTypingResponseSchema)` to create a new message.
 */
export const SetTypingResponseSchema: GenMessage<SetTypingResponse> = /*@__PURE__*/
  messageDesc(file_yofis_v1_chat, 28);

/**
 * Личные настройки чата.
 *
 * @generated from message yofis.v1.SetChatPrefsRequest
 */
export type SetChatPrefsRequest = Message<"yofis.v1.SetChatPrefsRequest"> & {
  /**
   * Идентификатор чата.
   *
   * @generated from field: string chat_id = 1;
   */
  chatId: string;

  /**
   * Без звука.
   *
   * @generated from field: bool muted = 2;
   */
  muted: boolean;

  /**
   * Закреплён в списке.
   *
   * @generated from field: bool pinned = 3;
   */
  pinned: boolean;

  /**
   * В архиве.
   *
   * @generated from field: bool archived = 4;
   */
  archived: boolean;

  /**
   * Какие из полей `muted`, `pinned`, `archived` менять.
   *
   * @generated from field: google.protobuf.FieldMask update_mask = 5;
   */
  updateMask?: FieldMask | undefined;
};

/**
 * Describes the message yofis.v1.SetChatPrefsRequest.
 * Use `create(SetChatPrefsRequestSchema)` to create a new message.
 */
export const SetChatPrefsRequestSchema: GenMessage<SetChatPrefsRequest> = /*@__PURE__*/
  messageDesc(file_yofis_v1_chat, 29);

/**
 * Ответ на личные настройки.
 *
 * @generated from message yofis.v1.SetChatPrefsResponse
 */
export type SetChatPrefsResponse = Message<"yofis.v1.SetChatPrefsResponse"> & {
  /**
   * Чат с новыми настройками.
   *
   * @generated from field: yofis.v1.Chat chat = 1;
   */
  chat?: Chat | undefined;
};

/**
 * Describes the message yofis.v1.SetChatPrefsResponse.
 * Use `create(SetChatPrefsResponseSchema)` to create a new message.
 */
export const SetChatPrefsResponseSchema: GenMessage<SetChatPrefsResponse> = /*@__PURE__*/
  messageDesc(file_yofis_v1_chat, 30);

/**
 * Удаление чата.
 *
 * @generated from message yofis.v1.DeleteChatRequest
 */
export type DeleteChatRequest = Message<"yofis.v1.DeleteChatRequest"> & {
  /**
   * Идентификатор чата.
   *
   * @generated from field: string chat_id = 1;
   */
  chatId: string;
};

/**
 * Describes the message yofis.v1.DeleteChatRequest.
 * Use `create(DeleteChatRequestSchema)` to create a new message.
 */
export const DeleteChatRequestSchema: GenMessage<DeleteChatRequest> = /*@__PURE__*/
  messageDesc(file_yofis_v1_chat, 31);

/**
 * Ответ на удаление чата; полей нет.
 *
 * @generated from message yofis.v1.DeleteChatResponse
 */
export type DeleteChatResponse = Message<"yofis.v1.DeleteChatResponse"> & {
};

/**
 * Describes the message yofis.v1.DeleteChatResponse.
 * Use `create(DeleteChatResponseSchema)` to create a new message.
 */
export const DeleteChatResponseSchema: GenMessage<DeleteChatResponse> = /*@__PURE__*/
  messageDesc(file_yofis_v1_chat, 32);

/**
 * Тип чата.
 *
 * @generated from enum yofis.v1.ChatType
 */
export enum ChatType {
  /**
   * Не задан.
   *
   * @generated from enum value: CHAT_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Личный чат двух пользователей.
   *
   * @generated from enum value: CHAT_TYPE_DIRECT = 1;
   */
  DIRECT = 1,

  /**
   * Группа.
   *
   * @generated from enum value: CHAT_TYPE_GROUP = 2;
   */
  GROUP = 2,

  /**
   * Канал: пишут только администраторы.
   *
   * @generated from enum value: CHAT_TYPE_CHANNEL = 3;
   */
  CHANNEL = 3,

  /**
   * Комната встречи (v1.5).
   *
   * @generated from enum value: CHAT_TYPE_ROOM = 4;
   */
  ROOM = 4,

  /**
   * Секретный чат E2EE — закладка (ADR-019, v2+).
   *
   * @generated from enum value: CHAT_TYPE_SECRET = 5;
   */
  SECRET = 5,
}

/**
 * Describes the enum yofis.v1.ChatType.
 */
export const ChatTypeSchema: GenEnum<ChatType> = /*@__PURE__*/
  enumDesc(file_yofis_v1_chat, 0);

/**
 * Роль участника в чате.
 *
 * @generated from enum yofis.v1.MemberRole
 */
export enum MemberRole {
  /**
   * Не задана.
   *
   * @generated from enum value: MEMBER_ROLE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Владелец: всё, включая удаление чата и передачу владения.
   *
   * @generated from enum value: MEMBER_ROLE_OWNER = 1;
   */
  OWNER = 1,

  /**
   * Администратор: участники, настройки, закрепы, удаление чужих сообщений.
   *
   * @generated from enum value: MEMBER_ROLE_ADMIN = 2;
   */
  ADMIN = 2,

  /**
   * Участник.
   *
   * @generated from enum value: MEMBER_ROLE_MEMBER = 3;
   */
  MEMBER = 3,

  /**
   * Гость (по ссылке-праву): пишет, если разрешено; не видит справочник.
   *
   * @generated from enum value: MEMBER_ROLE_GUEST = 4;
   */
  GUEST = 4,
}

/**
 * Describes the enum yofis.v1.MemberRole.
 */
export const MemberRoleSchema: GenEnum<MemberRole> = /*@__PURE__*/
  enumDesc(file_yofis_v1_chat, 1);

/**
 * Создание чатов, участники, личные настройки чата. Уровень всех методов — signed.
 *
 * @generated from service yofis.v1.ChatService
 */
export const ChatService: GenService<{
  /**
   * Личный чат с пользователем; идемпотентно — возвращает существующий.
   * Уровень: signed. Ошибки: USER_BLOCKED, BLOCKED_BY_PEER, USER_DEACTIVATED.
   *
   * @generated from rpc yofis.v1.ChatService.CreateDirectChat
   */
  createDirectChat: {
    methodKind: "unary";
    input: typeof CreateDirectChatRequestSchema;
    output: typeof CreateDirectChatResponseSchema;
  },
  /**
   * Создать группу; создатель становится OWNER.
   * Уровень: signed. Ошибки: IDEMPOTENCY_CONFLICT, invalid_argument (больше `Limits.max_group_members`).
   *
   * @generated from rpc yofis.v1.ChatService.CreateGroup
   */
  createGroup: {
    methodKind: "unary";
    input: typeof CreateGroupRequestSchema;
    output: typeof CreateGroupResponseSchema;
  },
  /**
   * Создать канал: `settings.only_admins_post` принудительно true.
   * Уровень: signed.
   *
   * @generated from rpc yofis.v1.ChatService.CreateChannel
   */
  createChannel: {
    methodKind: "unary";
    input: typeof CreateChannelRequestSchema;
    output: typeof CreateChannelResponseSchema;
  },
  /**
   * Чат по идентификатору.
   * Уровень: signed. Ошибки: NOT_MEMBER, not_found.
   *
   * @generated from rpc yofis.v1.ChatService.GetChat
   */
  getChat: {
    methodKind: "unary";
    input: typeof GetChatRequestSchema;
    output: typeof GetChatResponseSchema;
  },
  /**
   * Мои чаты: сначала закреплённые, затем по `updated_at` по убыванию.
   * Уровень: signed.
   *
   * @generated from rpc yofis.v1.ChatService.ListChats
   */
  listChats: {
    methodKind: "unary";
    input: typeof ListChatsRequestSchema;
    output: typeof ListChatsResponseSchema;
  },
  /**
   * Частичное обновление: `title`, `avatar_file_id`, `settings` (права по `ChatSettings.only_admins_edit_info`).
   * Уровень: signed. Ошибки: ROLE_REQUIRED.
   *
   * @generated from rpc yofis.v1.ChatService.UpdateChat
   */
  updateChat: {
    methodKind: "unary";
    input: typeof UpdateChatRequestSchema;
    output: typeof UpdateChatResponseSchema;
  },
  /**
   * Добавить участников (права по `ChatSettings.only_admins_invite`).
   * Уровень: signed. Ошибки: ROLE_REQUIRED, invalid_argument (лимит участников).
   *
   * @generated from rpc yofis.v1.ChatService.AddMembers
   */
  addMembers: {
    methodKind: "unary";
    input: typeof AddMembersRequestSchema;
    output: typeof AddMembersResponseSchema;
  },
  /**
   * Удалить участника: ADMIN/OWNER; удалённый получает `ChatRemoved(REMOVED)`.
   * Уровень: signed. Ошибки: ROLE_REQUIRED.
   *
   * @generated from rpc yofis.v1.ChatService.RemoveMember
   */
  removeMember: {
    methodKind: "unary";
    input: typeof RemoveMemberRequestSchema;
    output: typeof RemoveMemberResponseSchema;
  },
  /**
   * Выйти из чата. OWNER перед выходом назначает другого OWNER (`SetMemberRole`), иначе failed_precondition.
   * Уровень: signed.
   *
   * @generated from rpc yofis.v1.ChatService.LeaveChat
   */
  leaveChat: {
    methodKind: "unary";
    input: typeof LeaveChatRequestSchema;
    output: typeof LeaveChatResponseSchema;
  },
  /**
   * Сменить роль участника: OWNER — любую, ADMIN — только MEMBER↔ADMIN.
   * Уровень: signed. Ошибки: ROLE_REQUIRED.
   *
   * @generated from rpc yofis.v1.ChatService.SetMemberRole
   */
  setMemberRole: {
    methodKind: "unary";
    input: typeof SetMemberRoleRequestSchema;
    output: typeof SetMemberRoleResponseSchema;
  },
  /**
   * Участники чата.
   * Уровень: signed.
   *
   * @generated from rpc yofis.v1.ChatService.ListMembers
   */
  listMembers: {
    methodKind: "unary";
    input: typeof ListMembersRequestSchema;
    output: typeof ListMembersResponseSchema;
  },
  /**
   * Отметить прочитанным до сообщения включительно; монотонно — откат назад сервер игнорирует.
   * Уровень: signed.
   *
   * @generated from rpc yofis.v1.ChatService.MarkRead
   */
  markRead: {
    methodKind: "unary";
    input: typeof MarkReadRequestSchema;
    output: typeof MarkReadResponseSchema;
  },
  /**
   * «Печатает»: сервер рассылает `TypingUpdated` и сам гасит через 6 с.
   * Уровень: signed.
   *
   * @generated from rpc yofis.v1.ChatService.SetTyping
   */
  setTyping: {
    methodKind: "unary";
    input: typeof SetTypingRequestSchema;
    output: typeof SetTypingResponseSchema;
  },
  /**
   * Личные настройки чата: без звука, закреплён, в архиве.
   * Уровень: signed.
   *
   * @generated from rpc yofis.v1.ChatService.SetChatPrefs
   */
  setChatPrefs: {
    methodKind: "unary";
    input: typeof SetChatPrefsRequestSchema;
    output: typeof SetChatPrefsResponseSchema;
  },
  /**
   * Удалить чат для всех: OWNER группы/канала. Для DIRECT — только «скрыть у себя» (`archived`).
   * Уровень: signed. Ошибки: ROLE_REQUIRED.
   *
   * @generated from rpc yofis.v1.ChatService.DeleteChat
   */
  deleteChat: {
    methodKind: "unary";
    input: typeof DeleteChatRequestSchema;
    output: typeof DeleteChatResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_yofis_v1_chat, 0);

